// Target outbound clicks, including nested content and dynamically rendered buttons.
(function () {
  const targetPixel = document.querySelector('[data-target-meta-pixel]');
  if (!targetPixel || document.documentElement.dataset.targetMetaListenerAttached) return;
  document.documentElement.dataset.targetMetaListenerAttached = 'true';

  document.addEventListener('click', function (event) {
    if (!(event.target instanceof Element)) return;
    if (!event.target.closest('[data-target-meta-event="tracked"]')) return;
    if (typeof window.fbq !== 'function') return;

    window.fbq('trackSingleCustom', targetPixel.dataset.targetMetaPixel, 'BuyOnTargetClick', { value: 1.00, currency: 'USD' });
  }, true);
})();

// Global Video Play/Pause Toggle
  (function () {
    function initVideoToggles() {
      document.querySelectorAll('.video-wrapper').forEach(function (wrapper) {
        const video = wrapper.querySelector('video');
        const toggle = wrapper.querySelector('.play-pause-toggle');
        if (!video || !toggle) return;

        toggle.classList.toggle('is-playing', !video.paused);

        toggle.addEventListener('click', function () {
          if (video.paused) {
            video.play();
            toggle.classList.add('is-playing');
          } else {
            video.pause();
            toggle.classList.remove('is-playing');
          }
        });
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initVideoToggles);
    } else {
      initVideoToggles();
    }
  })();

// Global Dropdown Handler
  (function () {
    function initDropdowns() {
      document.querySelectorAll('.dropdown-toggle').forEach(function (toggle) {
        toggle.addEventListener('click', function () {
          const parent = this.closest('.dropdown-single');
          const isAlreadyOpen = parent.classList.contains('is-open');

          // Close all open dropdowns
          document.querySelectorAll('.dropdown-single.is-open').forEach(function (openItem) {
            openItem.classList.remove('is-open');
          });

          if (!isAlreadyOpen) {
            parent.classList.add('is-open');
          }
        });
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initDropdowns);
    } else {
      initDropdowns();
    }
  })();
  
// Care Guide Modal
function closeCareGuide() {
  var overlay = document.getElementById('care-guide-overlay');
  if (!overlay) return;
  overlay.classList.remove('is-open');
  document.getElementById('care-guide-image').src = '';
  document.body.style.overflow = '';
}

document.addEventListener('click', function(e) {
  const careTrigger = e.target.closest('.product-card-image-toggle');
  if (careTrigger) {
    document.getElementById('care-guide-image').src = careTrigger.dataset.url;
    document.getElementById('care-guide-overlay').classList.add('is-open');
    document.body.style.overflow = 'hidden';
    return;
  }

  if (e.target.closest('#care-guide-close') || e.target.id === 'care-guide-overlay') {
    closeCareGuide();
  }
});

document.addEventListener('keydown', function(e) {
  if (e.key === 'Escape') closeCareGuide();
});

// Product Size Guide modal.
// Delegated so the triggers keep working after <variant-selects> is re-rendered
// on a variant change. Each product section renders its own overlay, addressed
// by the trigger's data-size-guide-overlay attribute.
function closeSizeGuides() {
  document.querySelectorAll('.size-guide-overlay.is-open').forEach(function (overlay) {
    overlay.classList.remove('is-open');
  });
  document.body.style.overflow = '';
}

document.addEventListener('click', function(e) {
  const sizeGuide = e.target.closest('.size-guide');
  if (sizeGuide) {
    const overlay = document.getElementById('size-guide-overlay-' + sizeGuide.dataset.sizeGuideOverlay);
    if (!overlay) return;
    overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    return;
  }

  if (e.target.closest('.size-guide-modal__close') || e.target.classList.contains('size-guide-overlay')) {
    closeSizeGuides();
  }
});

document.addEventListener('keydown', function(e) {
  if (e.key === 'Escape') closeSizeGuides();
});

// Swiper - Collection Cards
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.ms-collection-slider .swiper').forEach(function(el) {
      new Swiper(el, {
        slidesPerView: 2.45,
        spaceBetween: 10,
        scrollbar: {
          el: el.querySelector('.ms-collection-slider.swiper-scrollbar'),
          draggable: true,
        },
        breakpoints: {
          1200: { slidesPerView: 6 },
          1000: { slidesPerView: 4.5 },
          800: { slidesPerView: 3.75 },
          700:  { slidesPerView: 3.25 },
          550:  { slidesPerView: 2.75 },
        },
      });
    });
  });

/**
 * Syncs the Kaching Bundles upsell product's Size dropdown to match
 * the main product's selected Size, per deal tier.
 *
 * Kaching's own "sync variants" setting only syncs the main product's
 * own line items (#1, #2, #3...) to each other. It does not extend to
 * a separate upsell product, so this bridges that gap.
 *
 * Install: paste into a "Custom Liquid" section right after the
 * Kaching Bundles app block, or add to theme.liquid before </body>,
 * wrapped in <script> tags, on product pages that use this app block.
 */
(function () {
  function syncUpsellSize(mainSelect) {
    var bar = mainSelect.closest('.kaching-bundles__bar');
    if (!bar) return;

    var upsellSelect = bar.querySelector(
      '.kaching-bundles__upsell select[aria-label="Size"]'
    );
    if (!upsellSelect) return;

    var targetValue = mainSelect.value;

    var hasOption = Array.prototype.some.call(
      upsellSelect.options,
      function (opt) {
        return opt.value === targetValue;
      }
    );
    if (!hasOption || upsellSelect.value === targetValue) return;

    upsellSelect.value = targetValue;
    upsellSelect.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function syncAllVisibleBars() {
    document
      .querySelectorAll(
        '.kaching-bundles__bar-variant-selector-wrapper select[aria-label="Size"]'
      )
      .forEach(syncUpsellSize);
  }

  // Fires when a shopper manually changes a main product's size dropdown
  // inside the Kaching widget itself.
  document.addEventListener('change', function (e) {
    var select = e.target;
    if (
      select.matches &&
      select.matches(
        '.kaching-bundles__bar-variant-selector-wrapper select[aria-label="Size"]'
      )
    ) {
      syncUpsellSize(select);
    }
  });

  // The page's own "Select Size" control (Shopify's <variant-selects>,
  // outside the Kaching widget entirely) is a separate set of radio
  // inputs, not a <select>, and Kaching does not relay its changes into
  // its own widget after the initial page load. So push the chosen
  // value into every visible bar's upsell Size select directly.
  function syncAllBarsToValue(targetValue) {
    document.querySelectorAll('.kaching-bundles__bar').forEach(function (bar) {
      var upsellSelect = bar.querySelector(
        '.kaching-bundles__upsell select[aria-label="Size"]'
      );
      if (!upsellSelect) return;

      var hasOption = Array.prototype.some.call(
        upsellSelect.options,
        function (opt) {
          return opt.value === targetValue;
        }
      );
      if (!hasOption || upsellSelect.value === targetValue) return;

      upsellSelect.value = targetValue;
      upsellSelect.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  document.addEventListener('change', function (e) {
    var input = e.target;
    if (
      input.matches &&
      input.matches('variant-selects input[type="radio"][name^="Size"]')
    ) {
      syncAllBarsToValue(input.value);
    }
  });

  // Kaching re-renders the widget when tiers/deal bars are switched,
  // and it also updates its own line-item selects (via a data-value
  // attribute, no DOM add/remove and no native "change" event) when the
  // page's main "Select Size" control changes. Watch attributes too so
  // that case is caught, not just childList/subtree changes.
  var root = document.querySelector('kaching-bundles-block');
  if (root) {
    var observer = new MutationObserver(function () {
      syncAllVisibleBars();
    });
    observer.observe(root, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['data-value'],
    });
  }

  // Catch the initial render too.
  syncAllVisibleBars();
})();

// Replo Amazon clicks on pages marked for TikTok tracking.
(function () {
  if (document.documentElement.dataset.amazonTiktokListenerAttached) return;
  document.documentElement.dataset.amazonTiktokListenerAttached = 'true';

  // Capture clicks before Replo handles navigation, including nested images.
  document.addEventListener('click', function (event) {
    if (!(event.target instanceof Element)) return;
    if (!event.target.closest('[data-amazon-tiktok-event="tracked"]')) return;
    if (!window.ttq || typeof window.ttq.instance !== 'function') return;

    window.ttq.instance('D0QUCRBC77U5V5P71E30').track('AddToCart');
  }, true);
})();

// AppLovin: copy the pixel's cookies onto the cart so they reach the order.
// The server-side purchase event (Shopify webhook -> Cloudflare -> AppLovin CAPI)
// never sees the browser, so without this it arrives without _axwrt/_axeid/_axart.
// Attributes starting with "_" are hidden from shoppers at checkout.
(function () {
  if (document.documentElement.dataset.applovinCartAttrsAttached) return;
  document.documentElement.dataset.applovinCartAttrsAttached = 'true';

 var COOKIES = ['_axwrt', '_axeid', '_axart'];
  var SENT_KEY = 'mellow_al_cart_attrs';
  var attempts = 0;

 function getCookie(name) {
   var m = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
   return m ? decodeURIComponent(m[1]) : '';
 }

 function sync() {
   attempts++;
   var attrs = {};
   COOKIES.forEach(function (name) {
     var v = getCookie(name);
     if (v) attrs[name] = v;
   });
   if (!attrs._axwrt && !attrs._axeid) {
     if (attempts < 4) setTimeout(sync, 2000);
     return;
   }
   var payload = JSON.stringify(attrs);
   try { if (sessionStorage.getItem(SENT_KEY) === payload) return; } catch (e) {}

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
   fetch(root + 'cart/update.js', {
     method: 'POST',
     headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
     body: JSON.stringify({ attributes: attrs })
   }).then(function (r) {
     if (r.ok) { try { sessionStorage.setItem(SENT_KEY, payload); } catch (e) {} }
   }).catch(function () {});
 }

 if (document.readyState === 'complete') setTimeout(sync, 1500);
  else window.addEventListener('load', function () { setTimeout(sync, 1500); });
})();
